<template>
    <div id="contenedor-eliminar-contrato-catalogo-conceptos">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar Catálogo </v-card-title>
        <v-card-text>
            <template v-if="sePuedeBorrarCatalogo">
                <span class="secondary--text">
                    Esta accion eliminará el catálogo de conceptos completo. ¿Desea continuar?
                </span>
            </template>
            <template v-else>
                <v-row class="mb-2">
                    <span class="secondary--text">
                        No se puede eliminar el catalogo debido a que:
                    </span>
                </v-row>
                <v-row>
                    <v-chip v-if="tieneEstimaciones" color="warning" class="mx-2">
                        Tiene estimaciones
                    </v-chip>
                    <v-chip v-if="tieneReportesFisiscos" color="warning" class="mx2">
                        Tiene reportes fisicos
                    </v-chip>
                </v-row>
            </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cancelar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixEliminarCatalogo"
            :disabled="enviandoFormulario || !sePuedeBorrarCatalogo"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CustomButton from '@/components/buttons/Button.vue';
import mixCatalogo from './mixCatalogo';

export default {
  name: 'EliminarCatalogoContrato',
  mixins: [mixCatalogo],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idContrato,
        };
      },
    },
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    actualizar() {
      this.$apollo.queries.contrato.refetch();
    },
    cancelar() {
      this.$emit('cerrar');
    },
    cerrar() {
      this.$emit('actualizarCatalogo');
      this.$emit('cerrar');
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    tieneReportesFisiscos() {
      if (this.getContrato.reportesFisicos.length > 0) return true;
      return false;
    },
    tieneEstimaciones() {
      if (this.getContrato.estimaciones.length > 0) return true;
      return false;
    },
    sePuedeBorrarCatalogo() {
      if (!this.tieneEstimaciones && !this.tieneReportesFisiscos) return true;
      return false;
    },

  },
  mounted() {
    this.actualizar();
  },

};
</script>

  <style>

  </style>
